<template>
  <div class="px-3 py-3">


    <div class="row">
      <div class="col-12 col-sm-6 col-xxl-2 col-xl-2 mb-2">
        <label class="smalllabel">Дата
          <span class="f-time-link">
               <a href="#" @click.prevent="this.setDate('now')">Сегодня</a><a href="#"
                                                                      @click.prevent="this.setDate('tomorrow')">Завтра</a>
          </span>
        </label>
        <div>
          <Datepicker
              :locale="locate"
              :lowerLimit="new Date()"
              weekdayFormat="EEEEE"
              v-model="datepicker"
              inputFormat="dd.MM.yyyy"
              class="form-control"/>
        </div>
      </div>
      <div class="col-12 col-sm-6 col-xxl-2  col-xl-3 mb-2">
        <label class="smalllabel">Центр</label>
        <div>
          <select v-model="office" class="form-select" @change="fakeSendForm">
            <option :selected="office == id" :value="id" :key="id" v-for="([id, title]) in sortedOfficeSelect">
              {{ title }}
            </option>
          </select>
        </div>
      </div>
      <div class="col-12 col-sm-6  col-xxl-2  col-xl-2 mb-2">
        <label class="smalllabel">Кол-во человек</label>
        <div>
          <select v-model="capacity" class="form-select" @change="fakeSendForm">
            <option :selected="capacity == id" :value="id" :key="id" v-for="(title,id) in $store.state.cpacitySelect">
              {{ title }}
            </option>
          </select>
        </div>
      </div>
      <div class="d-none d-lg-block col-12 col-md-6 col-xxl-4  col-xl-3 mb-2">
        <div class="d-flex">
          <div>
            <label>&nbsp;</label>
            <div><a href="#" @click.prevent="reset" class="btn btn-default btn-sm" data-pjax="0">Сбросить</a></div>
          </div>
          <div>
            <label>&nbsp;</label>
            <div>
              <button @click.prevent="collapseToggle" class="position-relative btn btn-link btn-sm text-nowrap">
                  <span v-show="$store.state.loading"
                        class="booking-filter-loader spinner-border spinner-border-sm text-primary"></span>
                <span v-if="!collapse">Еще фильтры</span>
                <span v-else>Скрыть</span>
              </button>
            </div>
          </div>
        </div>
      </div>
      <div>
        <Collapse :when="collapse" class="col-12 mb-2 collapses">
        <div class="row">
          <div class="col-12 col-lg-6 col-xxl-2 col-xl-3 mb-2 trigger-block">
            <label class="smalllabel">Свободное время:</label>
            <div>
              <Dropdown>
                <!-- trigger element -->
                <template #trigger>
                  <button class=" form-select">
                    с <span class="small">{{ timeFrom }} до {{ timeTo }}</span>
                  </button>
                </template>
                <!-- contents display in dropdown -->
                <div class="px-3 py-2">
                  <div class="small mb-2 text-muted">Поиск свободных ячеек по времени</div>
                  <div class="form-check form-switch mb-2 ">
                    <input @change="fakeSendForm" class="form-check-input" v-model="timeOn" type="checkbox" id="onOffTime">
                    <label class="form-check-label small" for="onOffTime">Вкл/Выкл фильтр времени</label>
                  </div>
                  <div :class="{disabled:!timeOn}">
                    <label class="mb-2">Время:</label>
                    <div class="mb-2">
                      <Slider @change="fakeSendForm" v-model="timeRange" :min="1" :max="48" :tooltips="false" :lazy="false" :disabled="!timeOn"/>
                    </div>
                    <div class="d-flex justify-content-between small">
                      <div>с {{ timeFrom }}</div>
                      <div>до {{ timeTo }}</div>
                    </div>
                  </div>
                </div>
              </Dropdown>
            </div>
          </div>
          <div class="col-12 col-lg-6 col-xxl-3 col-xl-4 mb-2 trigger-block">
            <label class="smalllabel">Цена:</label>
            <div>
              <Dropdown @change="fakeSendForm">
                <!-- trigger element -->
                <template #trigger>
                  <button class=" form-select">
                    от <span class="small"><span>{{ slidePrice[0] }}</span> ₽ до <span>{{ slidePrice[1] }}</span> ₽</span>
                    за 1 час.
                  </button>
                </template>
                <!-- contents display in dropdown -->
                <div class="px-3 py-2 price-dropdown">
                  <div class="small mb-2 text-muted">Поиск свободных ячеек по цене</div>
                  <label class="mb-2">Цена:</label>

                  <div class="mb-2">
                    <Slider @change="fakeSendForm"  v-model="slidePrice" :max="slidePriceDefault[1]" :tooltips="false" :step="10" :lazy="false"/>
                  </div>
                  <div id="priceslider" class="slider-round slider-styled mb-2"></div>
                  <div class="d-flex justify-content-between small">
                    <div>от {{ slidePrice[0] }} ₽</div>
                    <div>до {{ slidePrice[1] }} ₽</div>
                  </div>
                </div>
              </Dropdown>
            </div>
          </div>
          <div class="col-12 col-lg-6 col-xxl-3 col-xl-4 mb-2" v-if="Object.keys(this.$store.state.metroSelect).length">
            <label class="smalllabel">Метро:</label>
            <div>
              <select v-model="metro" class="form-select" @change="fakeSendForm">
                <option :selected="metro == id" :value="id" :key="id" v-for="(title,id) in $store.state.metroSelect">
                  {{ title }}
                </option>
              </select>
            </div>
          </div>
        </div>
        <div class="col-12 col-lg-12 col-xxl-8 col-xl-11 mb-2" v-if="getCabinetOptions.length">
          <label class="smalllabel">В кабинете:</label>
          <div class="multi">
            <VueMultiselect
                v-model="cabinetOptionsValue"
                tag-placeholder=""
                placeholder="Выбрать"
                deselectLabel="Отменить"
                selectedLabel=""
                selectLabel="Выбрать"
                label="name"
                track-by="id"
                :options="getCabinetOptions"
                :multiple="true"
                :taggable="true"
                @select="fakeSendForm"
                @remove="fakeSendForm"
            >
            </VueMultiselect>
          </div>
        </div>
      </Collapse>
      </div>
      <div class=" d-lg-none col-12 col-md-6 col-xxl-4  col-xl-3 mb-2">
        <div class="d-flex">
          <div>
            <div class="d-flex">
              <div><a href="#" @click.prevent="reset" class="btn btn-default btn-sm" data-pjax="0">Сбросить</a></div>
            </div>
          </div>
          <div>

            <div>
              <button @click.prevent="collapseToggle" class="position-relative btn btn-link btn-sm text-nowrap">
                  <span v-show="$store.state.loading"
                        class="booking-filter-loader spinner-border spinner-border-sm text-primary"></span>
                <span v-if="!collapse">Еще фильтры</span>
                <span v-else>Скрыть</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>

import {ru} from 'date-fns/locale'
import {dateFormat} from "@/dateFormat";
import Datepicker from 'vue3-datepicker'
import {Collapse} from 'vue-collapsed'
import Slider from '@vueform/slider'
import VueMultiselect from 'vue-multiselect'
import {Dropdown} from './../../assets/js/v-dropdown.js'
import 'vue3-datepicker/dist/vue3-datepicker.css'
var maxPriceSlider = 6000;
export default {
  name: "SearchForm",
  components: {
    Datepicker,
    Collapse,
    Dropdown,
    Slider,
    // eslint-disable-next-line vue/no-unused-components
    VueMultiselect
  },
  inject: ['timeSlideData'],
  props:{
    searchFormData:Object
  },
  data() {
    return {
      slidePriceDefault: [0, maxPriceSlider],
      slidePrice: [0, 0],
      timeRange: [1, 48],
      collapse: false,
      locate: ru,
      datepicker: '',
      date: '',
      office: '',
      metro: 0,
      capacity: 0,
      cabinetOptionsValue:[],
      timeOn: false
    }
  },
  updated() {

  },
  created() {
    this.start = true;
    this.slidePrice = this.slidePriceDefault

    if(Object.keys(this.searchFormData).length){
      this.office = this.searchFormData.officeId;
      this.date = this.searchFormData.date;
      this.capacity = this.searchFormData.capacity;

      // Добавляем объект date для сохраненного значения даты
      this.datepicker = new Date(this.date)

      if(this.searchFormData.time_to){
        this.timeOn = true
        this.collapse = true
        this.timeRange = [this.searchFormData.time_from, this.searchFormData.time_to];
      }
    }else{
      this.office = this.$store.state.officeSelectCurrent
      this.setDate()
    }

  },
  computed: {
    sortedOfficeSelect() {
      // Получаем пары [ключ, значение] из объекта
      const entries = Object.entries(this.$store.state.officeSelect);

      // Отделяем "0": "Все" от других значений
      const alwaysFirst = entries.find(([key]) => key === "0");
      const otherEntries = entries.filter(([key]) => key !== "0");

      // Сортируем остальные значения по алфавиту
      const sortedEntries = otherEntries.sort(([, a], [, b]) =>
          a.localeCompare(b, "ru")
      );

      // Возвращаем массив, где "Все" идет первым
      return [alwaysFirst, ...sortedEntries];
    },
    timeFrom() {
      return this.timeOn ? this.timeSlideData[this.timeRange[0]] : '--:--'
    },
    timeTo() {
      return this.timeOn ? this.timeSlideData[this.timeRange[1]] : '--:--'
    },
    // officeDefault(){
    //    return this.$store.state.officeSelectDefault
    // }
    getCabinetOptions(){
      if(Object.keys(this.$store.state.cabinetOptionsSelect).length){
        return JSON.parse(JSON.stringify(this.$store.state.cabinetOptionsSelect))
      }
      return [];
    }
  },
  watch: {
    office(val) {
      if (val > 0) {
        this.metro = 0;
      }
    },
    metro(val) {
      if (val > 0) {
        this.office = 0;
      }
    },
    datepicker(val) {
      this.date = dateFormat.formatDate(val)
      if (!this.start){
        this.fakeSendForm();
      }
      this.start = false; // этот флаг, чтобы не срабатывал запрос к api при загрузке, несколько раз, так как searchData меняется при первом запросе
      //
    },
    '$store.state.date'(val){
       this.datepicker = new Date(val)
    },
    '$store.state.loading'(val){
      // console.log('$store.state.loading');
      if(!val){
        this.office = this.$store.state.officeSelectCurrent;
      }
    },
    // '$store.state.officeSelectCurrent'(val){
    //   // this.datepicker = new Date(val)
    //   console.log('$store.state.officeSelectCurrent',val);
    //   this.office = val;
    // }
    // officeDefault(val){
    //    this.office = val
    // }
  },
  methods: {
    // timeSlide(val){
    //   this.timeRange = val;
    // },
    // priceSlide(val) {
    //   this.slidePrice = val
    // },
    collapseToggle() {
      this.collapse = !this.collapse
    },
    reset() {
      console.log("reset " + this.metro)
      // this.$store.dispatch('officeSelectCurrent', this.$store.state.officeSelectDefault);
      // this.$store.dispatch('officeSelectCurrent', -1);
      this.office = -2;//this.$store.state.officeSelectDefault
      this.setDate()
      this.capacity = 0
      this.metro = 0
      this.slidePrice = this.slidePriceDefault
      this.timeRange = [3, 6]
      this.timeOn = false
      this.cabinetOptionsValue = []
      this.date = dateFormat.formatDate(this.datepicker)
      this.fakeSendForm();
    },
    fakeSendForm() {
      // console.log('fakeSendForm',this.date)
      // this.$cookies.set('officeSelectCurrent', this.office, Infinity);
      // this.$store.dispatch('setOfficeCurrent', this.office);
      // console.log("metro " + this.metro)
      this.$emitter.emit('fakeSendForm', Object.assign({}, {
        date: this.date,
        officeId: this.office,
        capacity: this.capacity,
        metro: this.metro,
        price_start: this.slidePrice[0],
        price_end: this.slidePrice[1],
        time_from: this.timeOn ? this.timeRange[0] : 0,
        time_to: this.timeOn ? this.timeRange[1] : 0,
        cabinet_options: this.cabinetOptionsValue
      }))

    },
    setDate(type = '') {
      // let currentDate = new Date()
      let currentDate = dateFormat.getDateNowWithTimeZone()
      if (type == 'tomorrow') {
        currentDate.setDate(currentDate.getDate() + 1);
      }
      if (type == 'aftertomorrow') {
        currentDate.setDate(currentDate.getDate() + 2);
      }

      // this.date = dateFormat.formatDate(currentDate)
      this.datepicker = currentDate

    }
  }
}
</script>


<style>
.multi .multiselect__tags{
  padding: 8px 40px 0 8px;

  border-radius: 1.5rem;
  border: 1px solid #cfd5da;
}
.multi .multiselect__placeholder{
  margin-bottom: 0px;
  margin-left: 5px;
  padding-top: 0px;
}
.multi .multiselect__tag {
  background: #e07a5f;
  margin-bottom: 0px;
  border-radius: 12px;
}

.multi .multiselect__tag-icon::after {
   content: "×";
   color: #ffe5e5;
   font-size: 17px;
 }
.multi .multiselect__tag-icon {

  border-radius: 0px;
  width: 23px;
  padding-right: 3px;
}
.multi .multiselect__tag-icon:hover {
  background-color: #3f3f3f40;
}
.multi .multiselect__select:before{
  padding: 6px;
  line-height: 1.5;
  color: #212529;
  background-color: transparent;
  background-image: url(data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27%3e%3cpath fill=%27none%27 stroke=%27%23343a40%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%272%27 d=%27m2 5 6 6 6-6%27/%3e%3c/svg%3e);
  background-repeat: no-repeat;
  background-position: center;
  background-size: 16px 12px;
  top: 4px;
  border: none;

}


</style>
<style scoped>


.disabled {
  opacity: .3;
}

.price-dropdown {
  min-width: 280px;
}

.trigger-block .v-dropdown-trigger {
  display: block;
}

.collapses {
  transition: height 300ms cubic-bezier(0.3, 0, 0.6, 1);
}

.booking-filter-loader {
  position: absolute;
  top: -1.5rem;
  left: calc(50% - 0.5rem);
}

.smalllabel {
  font-size: .85rem;
  margin-left: .8rem;
  color: #313131;
}

.f-time-link {
  margin-left: .8rem;
}

.f-time-link a {

  color: #BE8A5E;
  font-weight: bold;
  font-size: .75rem;
}

.f-time-link a:not(:last-child) {
  margin-right: .5rem;
}

</style>


<style src="./../../assets/slider-default2.css"></style>
<style src="./../../assets/vue-multiselect.min.css"></style>
